import { computed } from 'vue';
import { getUserAddDataFromLocalStorage } from '@/utils/userUtils';

export function usePartnerType() {
  const partnerTypes = computed<string[]>(() => {
    const { partnerTypes } = getUserAddDataFromLocalStorage();
    return Array.isArray(partnerTypes) ? partnerTypes : [];
  });

  const isFleetPartnerOnly = computed(
    () => partnerTypes.value.length === 1 && partnerTypes.value[0] === 'FLEET_PARTNER'
  );

  const isApiPartnerOnly = computed(
    () => partnerTypes.value.length === 1 && partnerTypes.value[0] === 'API_PARTNER',
  );

  return { partnerTypes, isFleetPartnerOnly, isApiPartnerOnly };
}
